import yup from 'yup'

export default yup.object().shape({
  name: yup.string().required("Name can't be blank"),
  productCode: yup.string().required('You must choose a product'),
  startDate: yup.string().required('You must select a start date'),
  endDate: yup.string().required('You must select an end date')
})



// WEBPACK FOOTER //
// ./src/validations/plan.js